import ApolloClient from "apollo-client";
import i18next from "i18next";
import fetch from "unfetch";
import { getMainDefinition } from "@apollo/client/utilities";
import {
  InMemoryCache,
  IntrospectionFragmentMatcher,
} from "apollo-cache-inmemory";
import { ApolloLink, split } from "apollo-link";
import { onError } from "apollo-link-error";
import { WebSocketLink } from "apollo-link-ws";
import { createUploadLink } from "apollo-upload-client";

import introspectionQueryResultData, {
  GetNotificationsDocument,
} from "~/schemas/generated/graphql";
import { NOTIFICATIONS } from "~/constans/notifications";
import { useToken } from "~/hooks/token";

import { resolvers } from "./resolvers";
import { uploadFetch } from "./uploadFetch";

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData,
});

const cache = new InMemoryCache({ fragmentMatcher: fragmentMatcher });
cache.writeData({
  data: {
    getNotifications: [],
  },
});

const { token } = useToken();
const wsLink = new WebSocketLink({
  uri: `${
    (window.location.protocol === "https:" ? "wss://" : "ws://") +
    window.location.host
  }/graphql`,
  options: {
    reconnect: true,
    connectionParams: { token },
  },
});

const middlewareLink = new ApolloLink((operation, forward) => {
  operation.setContext({
    headers: {
      token,
    },
  });
  return forward(operation);
});

const onErrorNotification = (type, content) => {
  const query = GetNotificationsDocument;
  const queryResult = cache.readQuery({ query });
  const getNotifications = queryResult?.getNotifications || [];

  const newNotification = {
    id: Date.now() / 2,
    isOpen: true,
    type: type,
    status: null,
    label: null,
    content: content,
    duration: null,
    __typename: "Notification",
  };

  cache.writeQuery({
    query,
    data: {
      getNotifications: [newNotification, ...getNotifications],
    },
  });
};

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    console.log(graphQLErrors);
    graphQLErrors.map(({ extensions, message }) => {
      const code = extensions?.code;
      if (message !== "jwt malformed" && message !== "Данное имя занято") {
        onErrorNotification(
          NOTIFICATIONS.error,
          `${i18next.t("errors.was_error")}: ${code || "unknown"}`,
        );
        console.log(code);
        console.log(message);
      }
    });
  }
  if (networkError) {
    onErrorNotification(
      NOTIFICATIONS.error,
      `[Network error]: ${networkError}`,
    );
  }
});

const customFetch = (uri: any, options: any) => {
  if (options.useUpload) {
    return uploadFetch(uri, options);
  }
  return fetch(uri, options);
};

const httpLink = new (createUploadLink as any)({
  uri: `/graphql`,
  credentials: "same-origin",
  fetch: customFetch as any,
  fetchOptions: { fetch },
});

const setLink = middlewareLink.concat(httpLink);

export const client = new ApolloClient({
  cache,
  resolvers,
  link: ApolloLink.from([
    errorLink,
    split(({ query }) => {
      const { kind, operation }: any = getMainDefinition(query);
      return kind === "OperationDefinition" && operation === "subscription";
    }, wsLink),
    setLink,
  ]),
  connectToDevTools: true,

  //     ApolloLink.from([errorLink, setLink]),
});
